(function () {
    angular.module('emarket.main.post').controller('OfferController', ['$mdDialog', '$mdToast', 'offers', 'postId', 'Offer', function ($mdDialog, $mdToast, offers, postId, Offer) {
        var vm = this;
        vm.close = function () {
            $mdDialog.hide();
        };
        var sort = function (a, b) {
            return b.amount - a.amount;
        };
        vm.offers = offers.filter(function (offer) {
            return offer.status !== 'cancelled';
        }).sort(sort);
        vm.makeOffer = function () {
            var amount = vm.amount;
            vm.amount = null;
            vm.offers.push({
                amount: amount,
                status: 'pending',
                last: true
            });
            vm.offers = vm.offers.sort(sort);
            Offer.make(postId, amount).then(function () {
                vm.offers.forEach(function (offer) {
                    if (offer.last) {
                        offer.last = false;
                    }
                });
            }).catch(function (err) {
                var index;
                vm.offers.forEach(function (offer, i) {
                    if (offer.last) {
                        index = i;
                    }
                });
                if (index) {
                    vm.offers.splice(index, 1);
                }
                $mdToast.show($mdToast.simple().textContent(err.data.message));
            });
        };
    }]);
}());
